export default "__VITE_ASSET__axMGSrlz__"